import { createMetricsPublisher } from './metrics-publisher';
import { collectComponentMetrics } from './component-metrics';
const {
  publisher,
  sushiDriver
} = createMetricsPublisher();
collectComponentMetrics(publisher, sushiDriver);
//# sourceMappingURL=register-component-metrics.js.map